import { FC, ReactNode } from 'react';
import { Box, createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() =>
  createStyles({
    content: {
      height: '200px',
      maxHeight: '200px',
      minHeight: '200px',
      padding: '16px',
      marginTop: '16px',
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      overflowY: 'auto',
    },
  }),
);

type Props = {
  children?: ReactNode;
};

export const BlueprintCardContent: FC<Props> = ({ children }) => {
  const classes = useStyles();

  return <Box className={classes.content}>{children}</Box>;
};
